import { BaseMenuViewModel } from '../menu/base-menu-view-model';
import { Injectable } from '@angular/core';

@Injectable()
export class MenuWithPaginatedSectionsViewModel extends BaseMenuViewModel {}
